import { render, staticRenderFns } from "./FactFindPartnerDetails.vue?vue&type=template&id=a6be792c&"
import script from "./FactFindPartnerDetails.vue?vue&type=script&lang=ts&"
export * from "./FactFindPartnerDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports